/** Park codes: 6 characters from an alphabet without 0/O/1/I (same rule as the api). */
export const CODE_RE_CLIENT = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/;
